import React from 'react';
import { InstructionFormDetails } from '../../commonAfterFormPage/InstructionFormDetails';
import { NormalText } from '../../Styles';
import FrictionlessAfterFormSpecialComponent from './FrictionlessAfterFormSpecialComponent';
import config from '@app/config';

export const VietnamLightFrictionFormDetails: InstructionFormDetails = {
  instructionsSubTitle: 'supplierValidation.afterRegister.vietnamLightFriction.nowYouAreRegistered',
  paymentInstructionsTitle: 'supplierValidation.afterRegister.paymentInst',
  paymentInstructionsLines: [
    {
      description: 'supplierValidation.afterRegister.beneficiaryName',
      value: 'nsKnox Technologies, Inc',
    },
    {
      description: 'supplierValidation.afterRegister.address',
      value: '135 Madison Ave, New York, NY 10016',
    },
    {
      description: 'supplierValidation.afterRegister.checkingAccount',
      value: '466007904549',
    },
    {
      description: 'supplierValidation.afterRegister.swift',
      value: 'supplierValidation.afterRegister.bofaWire.swiftValues',
    },
  ],
  paymentInstructionsAddress: {
    description: 'supplierValidation.afterRegister.bankAndAddress',
    value: (
      <NormalText>
        Bank of America, 222 Broadway,
        <br />
        New York, NY 10038
      </NormalText>
    ),
  },
  currencies: [],
  pleaseNote: {
    pleaseNoteItem: [
      'supplierValidation.afterRegister.argentinaLightFriction.pleaseNote',
      'supplierValidation.afterRegister.argentinaLightFriction.haveTroubleLocatingInfo',
    ],
    hideInvoice: true,
  },
  showWireTransferWarningBox: {
    achWireTransfer: false,
    swiftWireTransfer: false,
  },
  extraInstructions: null,
  specialComponent: (
    <FrictionlessAfterFormSpecialComponent
      step1={'supplierValidation.afterRegister.vietnamLightFriction.willTransfer'}
      step2={'supplierValidation.afterRegister.vietnamLightFriction.uponReceiving'}
      withFieldInstructions={false}
    />
  ),
  downloadLink: `${config.supplierValidationAttachmentsUrl}VietnamLf/en/vietnam-lf.pdf`,
};
